// An email's campaign kept for the registration (Seán, 2026-10-29; the fullstack's
// claude/ANALYTICS.md § Campaigns on registrations): a page opened with utm_campaign in its
// address saves the campaign in the cookie vizbi_campaign, on vizbi.org (so fullstack.vizbi.org
// reads it too) for 30 days; the latest campaign wins, as in GA. The fullstack stores it with the
// registration (Clerk, Stripe). The same as the fullstack's plugins/campaignCookie.client.js.
const COOKIE = "vizbi_campaign";
const MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
const FIELDS = ["campaign", "source", "medium", "content"];

// {campaign, source, medium, content, at} from the address's utm_…, or null without a campaign
function getCampaign(search) {
  const params = new URLSearchParams(search);
  if (!params.get("utm_campaign")) return null;
  const entries = FIELDS.map((field) => [field, (params.get(`utm_${field}`) || "").slice(0, 100)]);
  return {...Object.fromEntries(entries), at: new Date().toISOString()};
}

// on vizbi.org and its subdomains; elsewhere (localhost, staging's vercel.app) this host only
function getDomainPart() {
  const host = window.location.hostname;
  return host === "vizbi.org" || host.endsWith(".vizbi.org") ? "; domain=.vizbi.org" : "";
}

export function saveCampaign() {
  try {
    const campaign = getCampaign(window.location.search);
    if (!campaign) return;
    const value = encodeURIComponent(JSON.stringify(campaign));
    const secure = window.location.protocol === "https:" ? "; secure" : "";
    document.cookie = `${COOKIE}=${value}; path=/; max-age=${MAX_AGE_SECONDS}; samesite=lax`
      + `${getDomainPart()}${secure}`;
  } catch {
    // never breaks the page
  }
}

export default {
  install() {
    saveCampaign();
  },
};
